export const InfoIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.75"
        y="0.75"
        width="16.5"
        height="16.5"
        rx="8.25"
        stroke="#A5A5A5"
        strokeWidth="0.5"
      />
      <path
        d="M9.00098 6.33862V6.33203"
        stroke="#6A6A6A"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00098 11.663V7.92969"
        stroke="#6A6A6A"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.0002 14.1992C11.8721 14.1992 14.2002 11.8711 14.2002 8.99922C14.2002 6.12734 11.8721 3.79922 9.0002 3.79922C6.12832 3.79922 3.8002 6.12734 3.8002 8.99922C3.8002 11.8711 6.12832 14.1992 9.0002 14.1992Z"
        stroke="#6A6A6A"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
